export default {
  namespaced: true,
  state: {
    order: {}
  },
  mutations: {
    changeOrder (state, val) {
      state.order = val
    }
  }
}
